<div>
    <p>{{ 'aumico_annual_report_special_flis_form_title' | i18next }}</p>
    <p>{{ 'aumico_annual_report_special_flis_form_intro' | i18next }}</p>
</div>
<div class="form-container">
    <div class="form-row">
        <div *ngIf="canUseEquity || canUseUncovershorfall" class="form-element">
            <aum-select
                placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                [aumFormControl]="formGroup.controls['equityGroup']"
                [options]="groupOptions"
            >
                <aum-form-field-label>
                    {{ 'aumico_annual_report_special_flis_equity_group_label' | i18next }}
                </aum-form-field-label>
            </aum-select>
        </div>
        <div class="form-element">
            <aum-select
                placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                [aumFormControl]="formGroup.controls['profitFLI']"
                [options]="fliOptions"
            >
                <aum-form-field-label>
                    {{ 'aumico_annual_report_special_flis_profit_fli_label' | i18next }}
                </aum-form-field-label>
            </aum-select>
        </div>
        <div class="form-element">
            <aum-select
                placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                [aumFormControl]="formGroup.controls['annualSurplusFli']"
                [options]="fliOptions"
            >
                <aum-form-field-label>
                    {{ 'aumico_annual_report_special_flis_annual_surplus_fli_label' | i18next }}
                </aum-form-field-label>
            </aum-select>
        </div>
    </div>
    <div class="form-row" *ngIf="canUseUncovershorfall">
        <div class="form-element">
            <aum-select
                placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                [aumFormControl]="formGroup.controls['uncoveredShortfallAssetsFli']"
                [options]="assetsFliOptions"
            >
                <aum-form-field-label>
                    {{ 'aumico_annual_report_special_flis_uncoveredShortfallAssets_label' | i18next }}
                </aum-form-field-label>
            </aum-select>
        </div>
        <div class="form-element">
            <aum-select
                placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
                [aumFormControl]="formGroup.controls['uncoveredShortfallLiabilitiesFli']"
                [options]="liaFliOptions"
            >
                <aum-form-field-label>
                    {{ 'aumico_annual_report_special_flis_uncoveredShortfallLiabilities_label' | i18next }}
                </aum-form-field-label>
            </aum-select>
        </div>
    </div>
</div>
